/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material/styles';

export const categoryImageSX: SxProps<Theme> = {
	display: 'block',
	transition: (theme) => theme.transitions.create('filter'),
	marginBottom: 1,
	overflow: 'hidden',
	flex: { xs: '1 0 200px', sm: '1 0 300px', md: '1 1 0%' },

	// '&:hover': {
	// 	filter: 'brightness(1.25)',
	// },

	'& > img': {
		display: 'block',

		paddingBottom: '.875rem',
		borderBottom: '1px solid',
		borderColor: 'primary.main',
		marginBottom: '.4375rem',

		// 4:5 aspect ratio
		maxWidth: '125%',
		width: '125%',
		marginLeft: '-12.5%',
	},
};
